import { CheckPermission } from "./acls";

export default {
    mixins: [
        CheckPermission
    ],
    data() {
        return {
            form: {
                id: null,
            },
        }
    },
    mounted() {
    },
    computed: {
        stateTools() {
            let code = this.moduleInternalCode || this.moduleCode;
            return code ? this.$store.getters.getStateTools(code) : [];
        },
        mapTools(){
            return this.stateTools;
        },
        canView() {
            return this.checkPermission(this.acl, 'view');
        },
        canDetail() {
            return this.checkPermission(this.acl, 'detail');
        },
        canAdd() {
            return this.checkPermission(this.acl, 'add');
        },
        canEdit() {
            return this.checkPermission(this.acl, 'edit');
        },
        canDelete() {
            return this.checkPermission(this.acl, 'delete');
        },
        canConfig() {
            return this.checkPermission(this.acl, 'config');
        },
        canConfigEdit() {
            return this.checkPermission(this.acl, 'configEdit');
        },
        readonlyFormItem() {
            return !(this.form.id && this.canEdit || !this.form.id && this.canAdd);
        },
        checkActions() {
            return this.canDelete || this.canEdit || this.canDetail;
        },
    },
    methods: {
        checkUserHasPermission(aclCode){
            return this.acl.allowAllChanges && this.$auth.check(this.acl.allowAllChanges)
                || aclCode && this.$auth.check(aclCode);
        },
        checkTool: function(key) {
            if(this.mapTools){
                let tool = this.mapTools.find( t => t.id == key);
                return !!(tool ? tool.active && (!tool.acl || tool.acl && this.$auth.check(tool.acl)) : false);
            }
            return false;
        },
    }
}
